import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const CONTROL_ENTITIES_TABLE_STATE_STORAGE_KEY =
    "userControlEntitiesList";

export const CONTROL_ENTITIES_LIST_COLUMN_IDS = {
    NAME: "name",
    DESCRIPTION: "description",
    CONTROL_ACCESS_RIGHT: "controlAccessRight",
    RISK_ACCESS_RIGHT: "riskAccessRight",
} as const;

export type AccessRightColumnId =
    | typeof CONTROL_ENTITIES_LIST_COLUMN_IDS.CONTROL_ACCESS_RIGHT
    | typeof CONTROL_ENTITIES_LIST_COLUMN_IDS.RISK_ACCESS_RIGHT;

export const controlEntitiesListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [{ id: CONTROL_ENTITIES_LIST_COLUMN_IDS.NAME, desc: false }],
    };

export const controlEntitiesListColumnFiltersCodecMap = {
    [CONTROL_ENTITIES_LIST_COLUMN_IDS.NAME]: withModeCodec(encodedArrayCodec),
    [CONTROL_ENTITIES_LIST_COLUMN_IDS.CONTROL_ACCESS_RIGHT]:
        withModeCodec(encodedArrayCodec),
    [CONTROL_ENTITIES_LIST_COLUMN_IDS.RISK_ACCESS_RIGHT]:
        withModeCodec(encodedArrayCodec),
};
